import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { LandingHero } from './components/LandingHero';
import { QuizStep } from './components/QuizStep';
import { QuizResults } from './components/QuizResults';
import { ProgressBar } from './components/ProgressBar';
const QUIZ_QUESTIONS = [{
  id: 1,
  question: '¿Cuál es tu mayor preocupación hoy?',
  options: [{
    id: '1a',
    label: 'Caída del óvalo facial/mandíbula',
    value: 3
  }, {
    id: '1b',
    label: 'Bolsas y ojeras persistentes',
    value: 2
  }, {
    id: '1c',
    label: 'Arrugas en frente y entrecejo',
    value: 1
  }, {
    id: '1d',
    label: 'Surco nasogeniano marcado',
    value: 2
  }]
}, {
  id: 2,
  question: 'Al presionar tu mejilla, ¿la piel regresa a su sitio instantáneamente?',
  options: [{
    id: '2a',
    label: 'Sí, de inmediato',
    value: 0
  }, {
    id: '2b',
    label: 'Tarda un par de segundos',
    value: 1
  }, {
    id: '2c',
    label: 'Noto cierta flacidez',
    value: 2
  }]
}, {
  id: 3,
  question: '¿Cuántas horas de pantalla (móvil/PC) pasas al día?',
  subtitle: 'La postura "tech-neck" debilita el cuello y la mandíbula',
  options: [{
    id: '3a',
    label: 'Menos de 3 horas',
    value: 0
  }, {
    id: '3b',
    label: 'Entre 3 y 6 horas',
    value: 1
  }, {
    id: '3c',
    label: 'Entre 6 y 10 horas',
    value: 2
  }, {
    id: '3d',
    label: 'Más de 10 horas',
    value: 3
  }]
}, {
  id: 4,
  question: '¿Sientes tu rostro cansado o "hinchado" al despertar?',
  options: [{
    id: '4a',
    label: 'Casi siempre',
    value: 2
  }, {
    id: '4b',
    label: 'Solo si duermo poco',
    value: 1
  }, {
    id: '4c',
    label: 'Nunca',
    value: 0
  }]
}, {
  id: 5,
  question: '¿Qué edad siente que tiene tu rostro comparado con tu edad real?',
  options: [{
    id: '5a',
    label: 'Menor',
    value: 0
  }, {
    id: '5b',
    label: 'Igual',
    value: 1
  }, {
    id: '5c',
    label: 'Mayor',
    value: 2
  }]
}];
export function App() {
  const [step, setStep] = useState(0); // 0 = Landing, 1-5 = Quiz, 6 = Results
  const [score, setScore] = useState(0);
  const handleStart = () => {
    setStep(1);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const handleAnswer = (value: number) => {
    setScore(prev => prev + value);
    setStep(prev => prev + 1);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-cream-100 bg-pattern flex flex-col font-sans" data-id="element-0">
      {/* Simple Header */}
      <header className="w-full py-6 px-4 flex justify-center items-center bg-white/50 backdrop-blur-md sticky top-0 z-50 border-b border-cream-200" data-id="element-1">
        <div className="text-2xl font-serif text-burgundy-800 tracking-wide font-medium flex items-center gap-2" data-id="element-2">
          <span className="w-8 h-8 rounded-full bg-burgundy-800 text-gold-400 flex items-center justify-center text-lg italic" data-id="element-3">
            V
          </span>
          Visage
        </div>
      </header>

      <main className="flex-grow flex flex-col items-center justify-center py-8 md:py-12 w-full" data-id="element-4">
        {step > 0 && step <= QUIZ_QUESTIONS.length && <ProgressBar currentStep={step} totalSteps={QUIZ_QUESTIONS.length} data-id="element-5" />}

        <div className="w-full relative" data-id="element-6">
          <AnimatePresence mode="wait" data-id="element-7">
            {step === 0 && <LandingHero key="landing" onStart={handleStart} data-id="element-8" />}

            {step > 0 && step <= QUIZ_QUESTIONS.length && <QuizStep key={`step-${step}`} question={QUIZ_QUESTIONS[step - 1].question} subtitle={QUIZ_QUESTIONS[step - 1].subtitle} options={QUIZ_QUESTIONS[step - 1].options} onSelect={handleAnswer} data-id="element-9" />}

            {step > QUIZ_QUESTIONS.length && <QuizResults key="results" score={score} data-id="element-10" />}
          </AnimatePresence>
        </div>
      </main>

      {/* Simple Footer */}
      <footer className="py-8 text-center text-slate-500 text-sm border-t border-cream-200 mt-auto" data-id="element-11">
        <p data-id="element-12">
          © {new Date().getFullYear()} Visage Dermocosmética. Todos los
          derechos reservados.
        </p>
      </footer>
    </div>;
}